import ConfigListStore from './ConfigListStore';
import ConfigUpsertStore from './ConfigUpsertStore';

const ConfigStore = {
  list: ConfigListStore,
  upsert: ConfigUpsertStore,
};

export default ConfigStore;
